<template>
  <div v-loading="loading" class="business-income-list-container">
    <div class="head flex-align-center">
      <div style="display: flex;align-items: center;">
        <el-form :model="query" size="mini" inline>
          <el-form-item>
            <el-date-picker
                v-model="query.date_range"
                type="monthrange"
                align="right"
                unlink-panels
                format="yyyy年MM月"
                value-format="yyyy-MM"
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-date-picker v-model="query.exec_timestamp"
                            style="width: 140px" type="month"
                            format="yyyy年MM月"
                            value-format="yyyy-MM"
                            placeholder="搜索月份"
            />
          </el-form-item>
          <el-form-item>
            <select-artist :value.sync="query.artist_id" style="width: 100%"/>
          </el-form-item>
          <el-form-item>
            <el-input style="width: 120px" v-model="query.agent_name" placeholder="经纪人" clearable />
          </el-form-item>
          <el-form-item>
            <el-input v-model="query.order_no" placeholder="订单编号" clearable/>
          </el-form-item>
          <el-form-item>
            <select-brand :value.sync="query.brand_id"/>
          </el-form-item>
          <el-form-item>
            <company-select :company-id.sync="query.company_id"/>
          </el-form-item>
          <el-form-item>
            <el-select style="width: 100px" v-model="query.is_confirm" placeholder="确认状态" clearable
                       @change="handleSearch" size="mini">
              <el-option label="已确认" value="Y"></el-option>
              <el-option label="未确认" value="N"></el-option>
            </el-select>
          </el-form-item>
<!--          <el-form-item>-->
<!--            <el-checkbox v-model="showOnlyMine" :disabled="!hasBusinessIncomeScopeAll" @change="handleSearch">-->
<!--              只看我的-->
<!--            </el-checkbox>-->
<!--          </el-form-item>-->
          <el-form-item>
            <el-button type="primary" size="mini" icon="el-icon-search" @click="handleSearch">
              查询
            </el-button>
          </el-form-item>
<!--          <el-form-item>-->
<!--            <export-by-page :tableName="tableName" module="BUSINESS_INCOME" type="text" :search="query"/>-->
<!--          </el-form-item>-->
          <!--          <el-form-item>-->
          <!--            <export-btn :query="query" :export-api="businessIncomeList" :export-name="'商务收入列表'"-->
          <!--            />-->
          <!--          </el-form-item>-->
          <el-form-item>
            <el-button v-permission="'business_income_confirm__btn'" type="success" size="mini" :disabled="pageSelectedList.length === 0" @click="handleConfirm">
              确认订单
            </el-button>
          </el-form-item>
<!--          <el-form-item>-->
<!--            <el-button size="mini" icon="el-icon-refresh" @click="handleRunScript">刷新数据-->
<!--            </el-button>-->
<!--          </el-form-item>-->
        </el-form>
      </div>
    </div>     <!--    广告订单列表表格  -->
    <div ref="tblDiv">
      <BusinessIncomeTable ref="refTableIBsAssistantOrder"
                           :query-params.sync="query"
                           :need-operate="false"
                           @refreshOrderList="getOrdersList"
                           @handleSelectionChange="handleSelectionChange"
                           @goDetail="goDetail" :selected-data.sync="pageSelectedList"
                           @clearData="clearData">
      </BusinessIncomeTable>
    </div>

    <!-- 确认弹框 -->
    <el-dialog
        title="确认收入信息"
        :visible.sync="confirmDialogVisible"
        width="800px"
        :close-on-click-modal="false">
      <div>
        <el-table :data="pageSelectedList" border size="mini">
          <el-table-column label="红人名称" prop="artist_nickname" width="130"/>
          <el-table-column label="经纪人" prop="agent_name" width="90"/>
          <el-table-column label="订单编号" align="right" width="120">
            <template v-slot="{ row }">
              {{ row.order_no }}
<!--              <to-order-detail by-field="order_no" :order="{ order_no: row.order_no, order_id: row.id }"/>-->
            </template>
          </el-table-column>
          <el-table-column label="可分配收入" align="right" width="120">
            <template v-slot="{row}">
<!--              广告收入 - 返点金额-->
              ￥{{ (Number(row.adv_revenue) - Number(row.rebates_amount)  || 0) | numberFormat(2) }}
            </template>
          </el-table-column>
          <el-table-column label="红人分成" align="right" width="120">
            <template v-slot="{row}">
              ￥{{ (row.artist_income || 0) | numberFormat(2) }}
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px; text-align: right; font-weight: bold;">
          总计广告收入：￥{{ moneyFormat(confirmTotalAmount) }}
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="confirmDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitConfirm">确定确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 全局方法

import SelectArtist from "@/components/Selects/artist.vue";
import SelectBrand from "@/components/Selects/brand.vue";
import { businessIncomeList, confirmIncome} from "@/api/incomeSummary";
import moment from "moment/moment";
import BusinessIncomeTable from "./table/BusinessIncomeTable.vue";
import CompanySelect from "@/views/adOrder/components/companySelect.vue";

import ExportByPage from "@/components/export/ByPage/index.vue";

export default {
  name: "incomeBusiness",
  components: {
    ExportByPage,
    CompanySelect,
    BusinessIncomeTable,
    SelectArtist,
    SelectBrand,
  },
  data() {
    return {
      tableName: 'business_income_table',
      loading: false,
      tableData: [],
      expandKeys: [],
      pageSelectedList: [],//预览数据列表
      query: {
        exec_timestamp: null,
        artist_id: null,
        agent_name: null,
        order_no: null,
        brand_id: null,
        company_id: null,
        date_range: [],
        ack_status: null,
        is_notify:'Y'
      },
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()]);
          }
        }, {
          text: '今年至今',
          onClick(picker) {
            const end = new Date();
            const start = new Date(new Date().getFullYear(), 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 6);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      isColSet: false,
      topHeight: 0,
      height: null,
      confirmDialogVisible: false,
      selectedOrders: [],
      businessIncomeList: businessIncomeList,
      showOnlyMine: true,
    };
  },
  computed: {
    confirmTotalAmount() {
      let total = 0;
      this.pageSelectedList.forEach((row) => {
        // 使用广告收入字段计算，而不是分成收入
        total += (row.adv_revenue || 0) / 1;
      });
      return total;
    },
    hasBusinessIncomeScopeAll() {
      const userAuth = localStorage.getItem('userAuth') ? JSON.parse(localStorage.getItem('userAuth')).value : {};
      return !!userAuth['business_income_scope_all'];
    }
  },
  created() {
    this.query.exec_timestamp = moment().subtract(1, 'month').format('YYYY-MM');
    this.getTableData(true)
  },
  mounted() {
    this.topHeight = this.$refs.tblDiv.offsetTop
    this.height = Number(window.screen.height) - Number(this.topHeight) - 230 + 'px'
  },
  methods: {

    eventSortMethod: function ({order, prop}) {
      let string = null;
      switch (order) {
        case 'descending':
          string = `${prop} desc`
          break;
        case 'ascending':
          string = `${prop} asc`
          break;
        default:
          break;
      }
      this.query.order_by = string
      this.getTableData(true)
    },
    handleSearch: function () {
      if (this.$refs['refTableIBsAssistantOrder'])
        this.$refs['refTableIBsAssistantOrder'].initList(true)
    },

    getSearch: function () {
      // 如果选择"只看我的"，则设置agent_name为当前用户姓名
      // if (this.showOnlyMine) {
      //   const user = getAuthUser();
      //   this.query.agent_name = user.name || null;
      // } else {
      //   this.query.agent_name = null;
      // }

      return this.query
    },
    getTableData: async function (is_search = false) {
      // 查询重置 page
      if (is_search) {
        this.query.page = 1
        this.query.page_size = 20
      }
      this.getSearch()
      this.loading = true
      const response = await businessIncomeList(this.query)
      this.loading = false
      this.tableData = response.model.data || []
      this.query.total = response.model.total || 0
    },
    changeTableSort(_) {
      const {prop, order} = _
      let order_by = null
      if (order) {
        order_by = order === 'ascending' ? `\`${prop}\` asc` : `\`${prop}\` desc`
      }
      this.queryParams.order_by = order_by
      this.getTableData()
    },
    handleSelectionChange(val) {
      this.selectedOrders = val
      this.addPreview()
    },
    //预览数据添加
    addPreview() {
      if (this.selectedOrders.length > 0) {
        this.selectedOrders.forEach((row) => {
          const currentIdIndex = this.pageSelectedList.findIndex(value => value.id === row.id)
          if (currentIdIndex === -1) {
            this.pageSelectedList.push({...row})
          }
        })
      }
    },
    //加载订单列表
    getOrdersList() {
      if (this.$refs['refTableIBsAssistantOrder'])
        this.$refs['refTableIBsAssistantOrder'].initList()
    },
    //预览数据-清空
    clearData() {
      this.pageSelectedList = []
      if (this.$refs['refTableIBsAssistantOrder'])
        this.$refs['refTableIBsAssistantOrder'].handleClearSelection()
    },
    goDetail(row) {
      //详情页面，修改页面
      this.editPage(row.id)
    },
    editPage(id) {
      const {href} = this.$router.resolve({
        name: 'editAdOrder',
        params: {id: id},
      });
      window.open(href, "_blank");
    },
    // 确认按钮点击事件
    handleConfirm() {
      this.confirmDialogVisible = true;
    },
    // 提交确认
    async submitConfirm() {
      try {
        const ids = this.pageSelectedList.map(item => item.id);
        const params = {
          ids: ids,
          type: 'business'
        };
        const { success } = await confirmIncome(params);

        if (success) {
          this.msgSuccess('确认成功');
          this.confirmDialogVisible = false;
          // 刷新数据
          this.getOrdersList();
        } else {
          this.$message.error('确认失败，请重试');
        }
      } catch (error) {
        this.$message.error('确认失败，请重试');
      }
    },
    moneyFormat(val) {
      return this.$utils.numberFormat(val, 2);
    },
  }
};
</script>


<style lang="scss">
.business-income-list-container {
  padding: 5px 10px;
  height: calc(100vh - 166px);

  .el-table .red-row {
    background: #ffeeee;
  }

  .el-table thead tr, .el-table thead th {
    background: white !important;
    color: #3c3c3c !important;
    font-weight: 600;
  }

  .flag-error {
    display: inline-block;
    width: auto;
    line-height: 17px;
    padding: 0 10px;
    border-radius: 9px;
    //border: 1px solid #ab0707;
    color: #FFFFFF;
    background-color: #ab0707;
    font-size: 12px;
    cursor: pointer;
  }

  .head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;

    .el-select {
      //width: 250px;
      margin-right: 12px;
    }
  }

  .ape-table-container {
    height: calc(100% - 206px) !important;
  }

  .tip-time {
    color: #8a8e99;
    font-size: 12px;
    margin-right: 10px;
  }

  .tip-help {
    margin-top: 40px;
    margin-bottom: 10px;
    padding: 8px 24px;
    overflow-y: auto;
    background-color: #FFF9FBFC;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    line-height: 22px;
    color: #666;
    border-radius: 9px;
    position: relative;
    box-sizing: border-box;
    height: 110px;
  }

  .tag {
    border-radius: 3px;
    background-color: #ffeef3;
    color: #fe346e;
    font-size: 12px;
    padding: 0 8px;
    height: 20px;
    line-height: 20px;
  }

  .el-table .cell {
    height: auto !important;
  }

  .el-table th.el-table__cell > .cell {
    min-height: 34px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .el-table .sort-caret.ascending {
    top: 7px !important;
  }

  .el-table .sort-caret.descending {
    bottom: 5px !important;
  }

  .over-hidden {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .live-sm:hover {
    .live-sm__mark {
      opacity: .7 !important;
    }
  }

  .live-sm {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    position: relative;
    cursor: pointer;

    &__mark {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #111;
      opacity: 0;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 4px;

      span {
        color: #FFFFFF;
        cursor: pointer;
      }
    }
  }

  .tableCon {
    height: calc(100% - 50px);
    overflow: scroll;
  }
}
</style>
